// Wave 20.49ce — Aero.chat branded map pins. Rider asked for a
// custom camera pin instead of the raw 📷 emoji. Rendered as
// SVG (inline for web mapboxgl.Marker DOM elements, as strings
// for anywhere else that needs raw markup).

import { colors } from '../theme';

// Teardrop pin with a camera silhouette (body + lens) in the
// brand green over a dark inner disc. 32×40 viewBox; anchor at
// bottom center for a Mapbox marker.
export function cameraPinSvgString(size = 32): string {
  const brand = colors.brand;
  const dark = '#0a100c';
  const h = Math.round(size * 40 / 32);
  return `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${h}" viewBox="0 0 32 40" aria-hidden="true">
  <defs>
    <filter id="cam-shadow" x="-40%" y="-20%" width="180%" height="140%">
      <feDropShadow dx="0" dy="1.5" stdDeviation="1.5" flood-color="#000" flood-opacity="0.55"/>
    </filter>
  </defs>
  <g filter="url(#cam-shadow)">
    <path d="M16 0 C7.16 0 0 7.16 0 16 c0 10.5 12.5 21.5 15 23.4 a1.6 1.6 0 0 0 2 0 C19.5 37.5 32 26.5 32 16 c0 -8.84 -7.16 -16 -16 -16 z"
          fill="${brand}" stroke="${dark}" stroke-width="1.5" />
    <circle cx="16" cy="16" r="10.5" fill="${dark}" />
    <rect x="8.5" y="12.5" width="15" height="9.5" rx="1.6" fill="${brand}" />
    <rect x="12" y="10.5" width="4.5" height="2.5" rx="0.7" fill="${brand}" />
    <circle cx="16" cy="17" r="3" fill="${dark}" />
    <circle cx="16" cy="17" r="1.7" fill="${brand}" />
    <circle cx="20.5" cy="14.2" r="0.7" fill="${dark}" />
  </g>
</svg>`.trim();
}
